import React, { useContext, useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import foodpageLogo from "../assets/logo.png";
import logoSmall from "../assets/favsss.png";
import { jwtDecode } from "jwt-decode";
import { AppContext } from "../context/AppContext";
import "../styles/style.css";

const NAV_SECTIONS = [
  // {
  //   id: "overview",
  //   label: "Overview",
  //   items: [
  //     {
  //       to: "/",
  //       label: "Dashboard",
  //       icon: "solar:home-smile-angle-outline",
  //       end: true,
  //     },
  //   ],
  // },
  {
    id: "reservations",
    label: "Reservations",
    items: [
      {
        to: "/scheduler",
        label: "Scheduler",
        icon: "mdi:calendar-clock-outline",
        match: ["/scheduler"],
      },
      {
        to: "/table-enquiry-list",
        label: "Today",
        icon: "mdi:calendar-blank",
        tab: 0,
      },
      {
        to: "/table-enquiry-list?tab=1",
        label: "Requests",
        icon: "mdi:inbox",
        tab: 1,
      },
      {
        to: "/table-enquiry-list?tab=2",
        label: "Upcoming",
        icon: "mdi:access-time",
        tab: 2,
      },
      // {
      //   to: "/table-enquiry-list?tab=approved",
      //   label: "Approved",
      //   icon: "mdi:calendar-check",
      //   tab: 2,
      // },
      // {
      //   to: "/table-enquiry-list?tab=cancelled",
      //   label: "Cancelled",
      //   icon: "mdi:calendar-remove",
      //   tab: 3,
      // },
      {
        to: "/table-enquiry-list?tab=3",
        label: "History",
        icon: "mdi:clock-arrow",
        tab: 3,
      },
      {
        to: "/reservation-settings",
        label: "More",
        icon: "mdi:dots-horizontal-circle-outline",
        match: [
          "/reservation-settings",
          "/reservation-preferences",
          "/reservation-timings",
          "/reservation-closures",
          "/dining-tables",
          "/create-reservation-settings",
          "/edit-reservation-settings",
        ],
      },
    ],
  },
  // {
  //   id: "promotions",
  //   label: "Promotions",
  //   items: [
  //     {
  //       to: "/promotion-list",
  //       label: "All promotions",
  //       icon: "mdi:tag-multiple-outline",
  //       match: ["/promotion-list", "/edit-promotion"],
  //     },
  //     {
  //       to: "/create-promotion",
  //       label: "Create promotion",
  //       icon: "mdi:plus-circle-outline",
  //     },
  //   ],
  // },
  // {
  //   id: "events",
  //   label: "Events",
  //   items: [
  //     {
  //       to: "/events",
  //       label: "Manage events",
  //       icon: "mdi:calendar-month-outline",
  //       match: ["/events"],
  //     },
  //     {
  //       to: "/create-new-event",
  //       label: "Add event",
  //       icon: "mdi:calendar-plus",
  //     },
  //   ],
  // },
];

const BOTTOM_NAV_ITEMS = [
  // {
  //   to: "/",
  //   label: "Dashboard",
  //   icon: "solar:home-smile-angle-outline",
  //   end: true,
  // },
  // {
  //   to: "/scheduler",
  //   label: "Scheduler",
  //   icon: "mdi:calendar-clock-outline",
  //   match: ["/scheduler"],
  // },
  {
    to: "/table-enquiry-list",
    label: "Today",
    icon: "mdi:calendar-blank",
    tab: 0,
  },
  {
    to: "/table-enquiry-list?tab=1",
    label: "Requests",
    icon: "mdi:inbox",
    tab: 1,
  },
  {
    to: "/table-enquiry-list?tab=2",
    label: "Upcoming",
    icon: "mdi:access-time",
    tab: 2,
  },
  {
    to: "/table-enquiry-list?tab=3",
    label: "History",
    icon: "mdi:clock-arrow",
    tab: 3,
  },
  {
    to: "/reservation-settings",
    label: "More",
    icon: "mdi:dots-horizontal-circle-outline",
    match: [
      "/reservation-settings",
      "/reservation-preferences",
      "/reservation-timings",
      "/reservation-closures",
      "/dining-tables",
      "/create-reservation-settings",
      "/edit-reservation-settings",
    ],
  },
];

const getEnquiryTab = (search) => {
  const tab = new URLSearchParams(search).get("tab");
  if (tab == null || tab === "") return 0;
  const parsed = parseInt(tab, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const isPathActive = (pathname, search, item) => {
  if (typeof item.tab === "number") {
    if (pathname !== "/table-enquiry-list") return false;
    return getEnquiryTab(search) === item.tab;
  }
  if (item.match?.length) {
    return item.match.some(
      (path) => pathname === path || pathname.startsWith(`${path}/`),
    );
  }
  if (item.end) return pathname === item.to;
  const pathOnly = String(item.to || "").split("?")[0];
  return pathname === pathOnly || pathname.startsWith(`${pathOnly}/`);
};

const MasterLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAdminToken, fetchShopSettings } = useContext(AppContext);
  const [collapsed, setCollapsed] = useState(false);
  const [shopName, setShopName] = useState("");
  const [shopDetails, setShopDetails] = useState(null);
  const [openSections, setOpenSections] = useState(() =>
    Object.fromEntries(NAV_SECTIONS.map((section) => [section.id, true])),
  );

  useEffect(() => {
    const init = async () => {
      const token = window.localStorage.getItem("UserRetention");

      if (token) {
        const decryptedData = jwtDecode(token);

        setShopName(decryptedData?.shopName ?? "");
        window.sessionStorage.setItem(
          "shopName",
          decryptedData?.shopName ?? "",
        );

        if (!shopDetails && decryptedData?.shopUrl) {
          await fetchShopData(decryptedData?.shopUrl);
        }
      }
    };

    init();
  }, []);

  const fetchShopData = async (shopUrl) => {
    await fetchShopSettings(shopUrl, {
      onSuccess: (res) => {
        setShopDetails(res?.data ?? null);
      },
      onFailed: (err) => {
        console.log("Error fetching shop settings:", err);
      },
    });
  };

  const userLogout = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    setAdminToken(null);
    setTimeout(() => {
      navigate("/login");
    }, 1000);
  };

  const toggleSection = (id) => {
    if (collapsed) return;
    setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const activeSectionIds = useMemo(() => {
    return NAV_SECTIONS.filter((section) =>
      section.items.some((item) =>
        isPathActive(location.pathname, location.search, item),
      ),
    ).map((section) => section.id);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!activeSectionIds.length) return;
    setOpenSections((prev) => {
      const next = { ...prev };
      activeSectionIds.forEach((id) => {
        next[id] = true;
      });
      return next;
    });
  }, [activeSectionIds]);

  const shopImage = shopDetails?.image || "";

  return (
    <div className={`app-shell ${collapsed ? "app-shell--collapsed" : ""}`}>
      <aside className="app-sidebar" aria-label="Main navigation">
        <div className="app-sidebar__top">
          <Link to="/" className="app-sidebar__brand" title="Foodpage">
            {/* <img
              src={logoSmall}
              alt=""
              className="app-sidebar__brand-mark"
            /> */}
            <img
              src={foodpageLogo}
              alt="Foodpage"
              className="app-sidebar__brand-wordmark"
            />
          </Link>

          <button
            type="button"
            className="app-sidebar__collapse-btn"
            onClick={() => setCollapsed((value) => !value)}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={collapsed ? "Expand" : "Collapse"}
          >
            <Icon
              icon={
                collapsed
                  ? "solar:alt-arrow-right-linear"
                  : "solar:alt-arrow-left-linear"
              }
            />
          </button>
        </div>

        <div className="app-sidebar__shop" title={shopName}>
          {shopImage ? (
            <img src={shopImage} alt="" className="app-sidebar__shop-avatar" />
          ) : (
            <span className="app-sidebar__shop-avatar app-sidebar__shop-avatar--fallback">
              {(shopName || "S").charAt(0).toUpperCase()}
            </span>
          )}
          <div className="app-sidebar__shop-meta">
            <span className="app-sidebar__shop-label">Shop</span>
            <strong className="app-sidebar__shop-name">
              {shopName || "Shop Admin"}
            </strong>
          </div>
        </div>

        <nav className="app-sidebar__nav">
          {NAV_SECTIONS.map((section) => {
            const isOpen = collapsed || openSections[section.id];
            const sectionActive = activeSectionIds.includes(section.id);

            return (
              <div
                key={section.id}
                className={`app-sidebar__section ${
                  sectionActive ? "is-active" : ""
                } ${isOpen ? "is-open" : ""}`}
              >
                <button
                  type="button"
                  className="app-sidebar__section-toggle"
                  onClick={() => toggleSection(section.id)}
                  aria-expanded={isOpen}
                >
                  <span>{section.label}</span>
                  <Icon
                    icon="solar:alt-arrow-down-linear"
                    className="app-sidebar__section-chevron"
                  />
                </button>

                <ul className="app-sidebar__list">
                  {section.items.map((item) => (
                    <li key={`${item.to}-${item.tab ?? item.label}`}>
                      <NavLink
                        to={item.to}
                        end={item.end}
                        title={item.label}
                        className={() =>
                          isPathActive(
                            location.pathname,
                            location.search,
                            item,
                          )
                            ? "app-sidebar__link is-active"
                            : "app-sidebar__link"
                        }
                      >
                        <Icon
                          icon={item.icon}
                          className="app-sidebar__link-icon"
                        />
                        <span className="app-sidebar__link-label">
                          {item.label}
                        </span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </nav>

        <div className="app-sidebar__footer">
          <button
            type="button"
            className="app-sidebar__logout"
            onClick={userLogout}
            title="Logout"
          >
            <Icon icon="mage:logout" className="app-sidebar__link-icon" />
            <span>Logout</span>
          </button>
          {/* <a
            href="https://foodpage.co.uk/"
            className="app-sidebar__powered"
            target="_blank"
            rel="noopener noreferrer"
            title="Powered by Foodpage"
          >
            <span>Powered by</span>
            <img src={foodpageLogo} alt="Foodpage" />
          </a> */}
        </div>
      </aside>

      <div className="app-shell__main">
        <header className="app-topbar">
          <div className="app-topbar__left">
            {shopImage ? (
              <img src={shopImage} alt="" className="app-topbar__shop-logo" />
            ) : null}

            <div className="app-topbar__titles">
              <img
                src={foodpageLogo}
                alt="Foodpage"
                className="app-topbar__brand"
              />
              <p className="app-topbar__shop-name" title={shopName}>
                {shopName || "Shop Admin"}
              </p>
            </div>
          </div>

          <div className="app-topbar__right">
            <button
              type="button"
              className="app-topbar__icon-btn"
              onClick={userLogout}
              aria-label="Logout"
              title="Logout"
            >
              <Icon icon="mage:logout" />
            </button>
          </div>
        </header>

        <main className="app-shell__body">{children}</main>

        <footer className="app-shell__footer">
          <a
            href="https://foodpage.co.uk/"
            className="app-shell__footer-brand"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Powered by</span>
            <img src={foodpageLogo} alt="Foodpage" />
          </a>
        </footer>
      </div>

      <nav className="app-bottom-nav" aria-label="Mobile navigation">
        {BOTTOM_NAV_ITEMS.map((item) => {
          const active = isPathActive(
            location.pathname,
            location.search,
            item,
          );
          return (
            <NavLink
              key={`${item.to}-${item.tab ?? item.label}`}
              to={item.to}
              end={item.end}
              className={
                active
                  ? "app-bottom-nav__item is-active"
                  : "app-bottom-nav__item"
              }
            >
              <span className="app-bottom-nav__icon-wrap">
                <Icon icon={item.icon} className="app-bottom-nav__icon" />
              </span>
              <span className="app-bottom-nav__label">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default MasterLayout;
